import {
    FC,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {createPropsGetter} from '../utils';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {JSX} from '../jsx-runtime';

export type ShowProps<T = any> = {
    when: T;
    fallback?: JSX.Element;
    children: ((data: T ) => JSX.Element) | JSX.Element;
};

/**
 * Remove or attach children's depending on `show` value.
 * Do not recreate or destroy them.
 * If `children` is a function, it will be called as a children provider.
 */
export const $Show: FC<ShowProps> = (props) => {
    return Store.computed(() => {
        const {when, fallback, children} = createPropsGetter(props);

        if (!when) {
            return fallback;
        }

        if (typeof children === 'function') {
            return children(when);
        }

        return children;
    });
};
